import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchCreditCardInfo,
  clearFetchCreditCardInfo,
  createStripeSetupIntent,
  clearStripeSetupIntent,
  updateCreditCard,
  clearUpdateCreditCard,
} from 'redux/billing/actions';

import { CardElement, injectStripe } from 'react-stripe-elements';

import Button from 'components/elements/buttons/Button';
import CommonLoader from 'components/common/CommonLoader';
import CommonMessage from 'components/common/CommonMessage';

import './UpdateCreditCardForm.css';

class UpdateCreditCardForm extends Component {
  static propTypes = {
    fetchCreditCardInfo: PropTypes.func.isRequired,
    clearFetchCreditCardInfo: PropTypes.func.isRequired,
    createStripeSetupIntent: PropTypes.func.isRequired,
    clearStripeSetupIntent: PropTypes.func.isRequired,
    updateCreditCard: PropTypes.func.isRequired,
    clearUpdateCreditCard: PropTypes.func.isRequired,
    setUpdateCreditCard: PropTypes.func.isRequired,
    me: PropTypes.object,
    stripeSetupIntent: PropTypes.object,
    stripeSetupIntentError: PropTypes.object,
    creditCardUpdated: PropTypes.object,
    creditCardUpdateError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    stripeSetupIntent: null,
    stripeSetupIntentError: null,
    creditCardUpdated: null,
    creditCardUpdateError: null,
  };

  state = {
    postToStripe: false,
    stripeCardError: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.stripeSetupIntent && this.props.stripeSetupIntent) {
      this._updateCreditCard();
    }

    if (!prevProps.creditCardUpdated && this.props.creditCardUpdated) {
      this._onCreditCardUpdated();
    }
  }

  componentWillUnmount() {
    this.props.clearStripeSetupIntent();
    this.props.clearUpdateCreditCard();
  }

  _createStripeSetupIntent = () => {
    const { me } = this.props;
    this.props.createStripeSetupIntent(
      me.subscription.billing_plan.id,
      me.subscription.billing_plan.interval,
    );
  };

  _updateCreditCard = () => {
    const cardElement = this.props.elements.getElement('card');
    this.setState({ postToStripe: true });

    this.props.stripe.confirmCardSetup(
      this.props.stripeSetupIntent.client_secret,
      {
        payment_method: {
          card: cardElement,
        },
      },
    ).then(result => {
      if (result.error){
        this.setState({ stripeCardError: result.error });
      }
      this.setState({ postToStripe: false });
      this.props.updateCreditCard(
        result.setupIntent.payment_method,
      );
    }).catch(() => {
      this.setState({ postToStripe: false });
    });

    this.props.clearStripeSetupIntent();
  };

  _onCreditCardUpdated = () => {
    this.props.setUpdateCreditCard(false);
    this.props.clearUpdateCreditCard();
    this.props.clearFetchCreditCardInfo();
    this.props.fetchCreditCardInfo();
  };

  render() {
    const { me, stripeSetupIntentError, creditCardUpdateError } = this.props;
    const { postToStripe } = this.state;
    if (!me.subscription || !me.subscription.billing_plan) return null;

    return (
      <Translation>
        {(t) => (
          <div className="update-credit-card-form__component">
            {/* Loader */}
            <CommonLoader active={postToStripe} />

            {/* Form */}
            <div className="credit-card-form">
              <CardElement />
            </div>

            {/* Buttons Block */}
            <div className="buttons-block">
              <Button
                borderedBlue
                onClick={() => this.props.setUpdateCreditCard(false) }
              >
                {t("Cancel")}
              </Button>
              <Button onClick={this._createStripeSetupIntent}>
                {t("Update Credit Card")}
              </Button>
            </div>

            {/* Errors */}
            <div className="errors-block">
              {stripeSetupIntentError &&
                <CommonMessage
                  error
                  errors={stripeSetupIntentError}
                />
              }

              {creditCardUpdateError &&
                <CommonMessage
                  error
                  errors={creditCardUpdateError}
                />
              }

              {this.state.stripeCardError &&
                <CommonMessage error>
                  {this.state.stripeCardError.message}
                </CommonMessage>
              }
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    stripeSetupIntent: state.billingReducer.stripeSetupIntent,
    stripeSetupIntentError: state.billingReducer.stripeSetupIntentError,
    creditCardUpdated: state.billingReducer.creditCardUpdated,
    creditCardUpdateError: state.billingReducer.creditCardUpdateError,
  }
);

export default injectStripe(connect(
  mapStateToProps,
  {
    fetchCreditCardInfo,
    clearFetchCreditCardInfo,
    createStripeSetupIntent,
    clearStripeSetupIntent,
    updateCreditCard,
    clearUpdateCreditCard,
  },
)(UpdateCreditCardForm));
